import { useState, useEffect } from 'react';
import { DayPicker, getDefaultClassNames } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import './calendar.css';

import { fetchCalendarStatus } from '../services/appointmentSlotService';

export default function AppointmentCalendar({
  onDateClick,
}: {
  onDateClick: (dateStr: string) => void;
}) {
  const defaultClassNames = getDefaultClassNames();
  const today = new Date();
  const [fullyBookedDates, setFullyBookedDates] = useState<Date[]>([]);
  const [currentMonth, setCurrentMonth] = useState<Date>(today);

  useEffect(() => {
    const loadCalendar = async () => {
      try {
        const year = currentMonth.getFullYear();
        const month = String(currentMonth.getMonth() + 1).padStart(2, '0');
        const monthStr = `${year}-${month}`; // "YYYY-MM"

        const data = await fetchCalendarStatus('aerocomp', monthStr);
        // expected: [{ date: "YYYY-MM-DD", slots: [{ isBooked: boolean, ...}, ...] }, ...]

        const fully: Date[] = [];

        (data || []).forEach((day: any) => {
          const dateStr = day.date; // "YYYY-MM-DD"
          const slots = day.slots || [];

          if (
            slots.length > 0 &&
            slots.every((s: any) => s.isBooked === true)
          ) {
            fully.push(new Date(dateStr));
          }
        });

        setFullyBookedDates(fully);
      } catch (err) {
        console.error('Failed to load calendar', err);
        setFullyBookedDates([]);
      }
    };

    loadCalendar();
  }, [currentMonth]);

  return (
    <div className="w-full max-w-md rounded-md bg-gray-900/40 p-2 text-sm">
      <DayPicker
        mode="single"
        disabled={{ before: today }}
        month={currentMonth}
        onMonthChange={setCurrentMonth}
        modifiers={{ fullyBooked: fullyBookedDates }}
        onDayClick={(date) => {
          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, '0');
          const d = String(date.getDate()).padStart(2, '0');

          const dateStr = `${y}-${m}-${d}`;

          const isFully = fullyBookedDates.some(
            (d2) => d2.toDateString() === date.toDateString(),
          );

          if (isFully) {
            alert('⚠ This day is fully booked.');
          }

          onDateClick(dateStr);
        }}
        classNames={{
          today: 'my-today',
          selected: 'my-selected',
          months: 'flex flex-wrap justify-center w-full',
          month: 'w-full max-w-full text-white',
          caption_label: 'text-center text-cyberred font-bold',
          day: 'p-0',
          day_button: 'w-full h-full p-2 flex items-center justify-center',
          weekday: 'font-semibold justify-center',
          month_grid: 'w-full border-collapse',
        }}
      />
    </div>
  );
}
